import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigProductService } from '../config_product.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'configure-product-group',
    templateUrl: './config_product_group.component.html'
})
export class ConfigureProductGroup {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    productGroupId = '';
    productGroupName = '';
    productGroupCode = '';
    ButtonValue = 'Save';
    productGroupType = '';
    IndividualChecked = false;
    GroupChecked = false;
    IsFormValid = false;
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: ConfigProductService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService.GetProductGroup(null)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });


    }


    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetProductGroup(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.productGroupName = obj["name"];
        this.productGroupCode = obj["code"];
        this.productGroupId = obj["id"];
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Update';
        this.productGroupType = obj["productGroupType"];
        this.CreatedBy = obj["productGroupType"];
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.productGroupName = obj["name"];
        this.productGroupCode = obj["code"];
        this.productGroupId = obj["id"];
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';
        this.productGroupType = obj["productGroupType"];
    }
    reset() {
        this.viewMode = false;
        this.productGroupName = '';
        this.productGroupCode = '';
        this.productGroupId = '';
        this.IsRecordUpdated = false;
        this.ButtonValue = 'Save';
    }

    memberFormSubmit() {
        this.IsFormValid = true;
        this.productGroupType = '';
        if (this.IndividualChecked) {
            this.productGroupType = "Individual";
        }
        if (this.GroupChecked) {
            this.productGroupType = "Group";
        }

        if (this.productGroupType == '') {
            this.toastr.error("Please select product type");
            this.IsFormValid = false;
            return false;
        }
        if (this.IsFormValid) {
            if (this.productGroupId != '') {
                let data = {
                    "Code": this.productGroupCode,
                    "Id": this.productGroupId,
                    "Name": this.productGroupName,
                    "productGroupType": this.productGroupType,
                    "LastModifiedBy": '',
                    "CreatedBy": this.CreatedBy
                }

                this.PaymentService.EditProductGroup(data)
                    .subscribe(departmentListData => {
                        if (departmentListData == "Success") {
                            this.toastr.success("Record updated succesfuly.");
                        }
                        else {
                            this.toastr.error("Name,Code and their combination must be Unique");
                        }
                    });
            }
            else {
                let data = {
                    "Code": this.productGroupCode,
                    "Name": this.productGroupName,
                    "productGroupType": this.productGroupType,
                    "LastModifiedBy": '',
                    "CreatedBy": "",
                    "id": ''
                }
                this.PaymentService.CreateProductGroup(data)
                    .subscribe(departmentListData => {
                        if (departmentListData == "Success") {
                            this.toastr.success("Record Added succesfuly.");
                        }
                        else {
                            this.toastr.error("Name,Code and their combination must be Unique");
                        }
                    });
            }
        }

    }

    codegen() {
        this.PaymentService.codeGen(this.productGroupName)
            .subscribe(departmentListData => {
                this.productGroupCode = departmentListData;
            });
    }

    deleteProdutConfirm(id,i) {
        this.productGroupId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data={
            "id": this.productGroupId,
            "trackingState": this.DeletedIndex
        }
        this.PaymentService.DeleteProductGroup(data)
            .subscribe(departmentListData => {

            });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.productGroupId ='';
        this.DeletedIndex ='';
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/configure_product/config_product_group/config_product_group.component.ts